import { useMemo, useState } from "react";
import useCloseSelector from "../../../../../../hooks/useCloseSelector";
import useFriendlyAddress from "../../../../../../hooks/useFriendlyAddress";
import { useTonConnectUI, useTonWallet } from "@tonconnect/ui-react";
import useWalletStore from "../../../../../../stores/WalletStore/useWalletStore";
import useTruncateString from "../../../../../../hooks/useTruncateString";

const useConnectButton = () => {
  const [connectMenuStatus, setConnectMenuStatus] = useState(false);
  const { ref } = useCloseSelector(() => setConnectMenuStatus(false));
  const [tonConnectUI] = useTonConnectUI();
  const wallet = useTonWallet();
  const userAddress = useFriendlyAddress(wallet?.account.address);
  const friendlyAddress = useFriendlyAddress(wallet?.account.address);
  const truncatedAddress = useTruncateString(friendlyAddress || "", 4, 4);
  const connectButtonText = useMemo(
    () => (friendlyAddress ? truncatedAddress : "Connect"),
    [wallet]
  );

  const onClick = () => {
    setConnectMenuStatus(!connectMenuStatus);
  };

  const logoutClick = () => {
    tonConnectUI?.disconnect();
  };

  return {
    onClick,
    ref,
    connectButtonText,
    wallet,
    connectMenuStatus,
    userAddress,
    logoutClick,
  };
};

export default useConnectButton;
